module.exports = __webpack_public_path__ + "img/meter-reset.d0033403.svg";